import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUser } from 'context/UserContext'
import { ChoiceButton } from 'components/ChoiceButton'
import { ButtonWrapper } from 'components/ButtonWrapper'
import { Heading } from 'components/Heading'

interface Props {
  nextRoute: string
}

export const FitnessLevel: React.FC<Props> = ({ nextRoute }) => {
  const { t } = useTranslation('translation', {
    useSuspense: false,
  })

  const navigate = useNavigate()
  const { user, setUser } = useUser()
  const genderBasedBackground =
    user.gender === 'm'
      ? 'bg-fitness-level-male bg-center'
      : 'bg-fitness-level-female bg-center'

  const onButtonClick = (fitness: string) => {
    setUser({ ...user, fitness })
    navigate(nextRoute)
  }

  return (
    <div className={`default-container ${genderBasedBackground} flex flex-col`}>
      <div className="flex h-full flex-col justify-between self-center overflow-auto px-7 pb-10 pt-7 lg:w-5/6 xl:w-5/12">
        <Heading text={t('fitness_level.headline')} />

        <ButtonWrapper>
          <ChoiceButton
            onClick={() => onButtonClick('beginner')}
            value={t('fitness_level.option_1')}
            id="beginner"
          />
          <ChoiceButton
            onClick={() => onButtonClick('intermediate')}
            value={t('fitness_level.option_2')}
            id="intermediate"
          />
          <ChoiceButton
            onClick={() => onButtonClick('advanced')}
            value={t('fitness_level.option_3')}
            id="advanced"
          />
        </ButtonWrapper>
      </div>
    </div>
  )
}
